import React, { useState, useEffect } from 'react'
import {
  Button,
  Input,
  InputNumber,
  Row,
  Col,
  Form,
  message,
  Card,
  Spin,
  Tooltip
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useDispatch, useStore, useSelector } from 'react-redux'
import RegistorclosePic from '../../../assets/images/close-register.PNG'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { notAllowMsgCheck } from '../../../appRedux/actions/GlobalMethods'
import {
  loadIsRegistorOpen,
  loadIsRegistorLoading,
  loadOpenCloseListingDataLoad
} from '../../../appRedux/actions/Sell'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import InfoToPrint from '../../../components/InfoToPrint'
import { PRINT_TYPES } from '../../../constants/StoreSetting'
import {
  loadOpenClosePrintData,
  loadShowPrintOpenClose
} from '../../../appRedux/actions'

const FormItem = Form.Item

const OpeningFloat = props => {
  const isCashManage = props.isCashManage ? props.isCashManage : false
  const isCreateDisable = props.isCreateDisable ? props.isCreateDisable : false
  // const promoID = match.params.id;
  const history = useHistory()
  const store = useStore()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  // const getReduxOpenListingDataLoad = useSelector(
  //   ({ Sell }) => Sell.openCloseListingDataLoad
  // );

  const [getIsSpinning, setIsSpinning] = useState(false)
  // const [showPrint, setShowPrint] = useState(0)
  // const [printData, setPrintData] = useState({})

  // React.useEffect(() => {}, []);

  async function postCashService (body, behavior) {
    // ;
    const cashInOutService = ds.postCashManagementService(body, behavior)
    await cashInOutService
      .then(res => {
        setIsSpinning(false)
        if (res && res.msg && res.msg == 'Register Opened') {
          if (res.type && res.type == PRINT_TYPES.opening) {
            dispatch(loadOpenClosePrintData(res))
            dispatch(loadShowPrintOpenClose(true))
          }
          localStorage.setItem('closedCashManageID', '')
          dispatch(loadIsRegistorOpen(true))
          dispatch(loadIsRegistorLoading(true))
          if (window.location.pathname.includes('/openclose/listing')) {
            history.push('/dashboard/sell/mainsale/webregister')
          }
          // dispatch(loadOpenCloseListingDataLoad(!getReduxOpenListingDataLoad)); //to load data in Open/Close -> OpenListing
        } else {
          dispatch(loadIsRegistorOpen(false))
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsSpinning(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      })
  }

  const onFinishFailed = errorInfo => {
    message.error('Please Try Again...')
  }

  // const onFinish = async (values) => {};
  const onFinish = values => {
    // ;
    let localRegID =
      localStorage.getItem('selectedReg') != ''
        ? JSON.parse(localStorage.getItem('selectedReg'))
        : false
    let regID =
      getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
        ? getReduxSelectedOutletReg.id
        : localRegID && localRegID.id
        ? localRegID.id
        : false
    if (regID) {
      dispatch(loadIsRegistorLoading(true))
      let body = {
        Amount: values.amount ? values.amount : 0,
        Note: values.note,
        IsOpening: true,
        RegisterID: regID
      }
      postCashService(body, BEHAVIOUR_TYPE.POST)
      form.setFieldsValue({ amount: '' })
      form.setFieldsValue({ note: '' })
    } else {
      message.info(
        'Kindly click Sell Menu & select Outlet/Register from left sidebar to open cash flow',
        6
      )
    }
  }

  return (
    <>
      <Spin
        tip={<IntlMessages id='products.promoadd.loadpromocodes' />}
        spinning={getIsSpinning}
        size='large'
      >
        <Card className='noborder'>
          <div className='gx-login-content gx-text-center dk-opening-float'>
            {isCashManage && (
              // className="gx-login-header"
              <Row className='align-items-center'> 
                <Col lg={24} md={24} sm={24} xs={24}>
                  <img src={RegistorclosePic} alt='' className='reg-close-img' />
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <h1 className='mb-1'>
                    <IntlMessages id='sell.cashlisting.regstrclosed' />
                  </h1>
                  <p className='mb-0'>
                    <IntlMessages id='sell.cashlisting.regstrclosedsub' />
                  </p>
                </Col>
              </Row>
            )}

            {/* <div className="gx-mb-4"></div> */}

            <Form
              initialValues={{ remember: true }}
              name='openingFloat'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className='gx-signin-form gx-form-row0'
              layout='vertical'
              size='large'
            >
              <FormItem
                // rules={[
                //   { required: true, message: "Please enter your amount!" },
                // ]}
                label={
                  <span>
                    <strong>
                      <IntlMessages id='sell.cashlisting.openingfloat' />
                    </strong>
                  </span>
                }
                name='amount'
              >
                <InputNumber
                type="number"
                  className='gx-input-lineheight w-100'
                  placeholder='Opening amount'
                  min={0}
                  max={100000000}
                  step={0.1}
                  defaultValue={0}
                  onFocus={e => e.target.select()}
                />
              </FormItem>

              <FormItem
                label={
                  <span>
                    <strong>
                      <IntlMessages id='sell.cashlisting.notes' />
                    </strong>
                  </span>
                }
                name='note'
              >
                <Input.TextArea
                  // className="gx-input-lineheight ponka"
                  placeholder='Enter a note'
                  rows={2}
                  // onChange={getCardPromoDesc}
                />
              </FormItem>

              <FormItem>
                {isCreateDisable || !isOnline ? (
                  <Tooltip
                    title={
                      <IntlMessages id='sell.sell.retrievesell.accessadenied' />
                    }
                    color={'red'}
                  >
                    <Button
                      className="OpenRegister-btn"
                      type='primary'
                      disabled
                    >
                      <IntlMessages id='sell.cashlisting.openregister'></IntlMessages>
                    </Button>
                  </Tooltip>
                ) : (
                  <Button
                    className='custom-searchbtn w-100 OpenRegister-btn'
                    type='primary'
                    htmlType='submit'
                    size='large'
                  >
                    <IntlMessages id='sell.cashlisting.openregister'></IntlMessages>
                  </Button>
                )}
              </FormItem>
            </Form>
          </div>
        </Card>
      </Spin>
    </>
  )
}

// ReactDOM.render(<PromoCodes />, mountNode);

export default OpeningFloat
